import { Link } from 'react-router-dom';
import { useEffect } from 'react';

const CtaSection = () => {
  // Optional: log image loading errors without breaking the UI
  useEffect(() => {
    const img = new Image();
    img.src =
      'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/72f95f79575f04d2e5e777734d1956f7.jpeg';
    img.onerror = (e) => {
      console.error('Background image failed to load', e);
    };
  }, []);

  return (
    <section className="py-16 md:py-24 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/72f95f79575f04d2e5e777734d1956f7.jpeg"
          alt="印刷製品"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/50"></div>
      </div>

      <div className="relative z-10 px-4 md:px-8 lg:px-16">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
            お気軽にご相談ください
          </h2>
          <p className="text-lg md:text-xl text-white/90 mb-12">
            お見積もりは無料です。<br className="md:hidden" />
            お電話またはお問い合わせフォームからお気軽にどうぞ。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-6">
            <a
              href="tel:086-012-3456"
              className="w-full sm:w-auto px-8 py-4 bg-primary text-white rounded-full font-bold text-base md:text-lg hover:bg-primary-dark transition-all duration-300 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-xl"></i>
              086-012-3456
            </a>

            <Link
              to="/contact"
              className="w-full sm:w-auto px-8 py-4 bg-white text-primary border-2 border-primary rounded-full font-bold text-base md:text-lg hover:bg-primary hover:text-white transition-all duration-300 flex items-center justify-center gap-2 whitespace-nowrap"
            >
              <i className="ri-mail-line text-xl"></i>
              お問い合わせフォーム
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;
